import React from "react";
import { CalendarClock } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { getSubscriptionNotice, SUBSCRIPTION_STYLES } from "../lib/subscription";

export function SubscriptionNotice({ org, compact = false }) {
  const notice = getSubscriptionNotice(org);
  if (!notice) return null;

  const styles = SUBSCRIPTION_STYLES[notice.level];

  if (compact) {
    const compactColor =
      notice.level === "danger" || notice.level === "urgent"
        ? "text-red-800"
        : notice.level === "warn"
          ? "text-amber-900"
          : "text-[#1B4332]";
    return (
      <p className={`text-[11px] leading-snug mt-1 ${compactColor}`} data-testid="subscription-sidebar-hint">
        <span className="font-medium">{notice.title}</span>
        {notice.level !== "danger" && (
          <span className="block text-[10px] opacity-90 mt-0.5">{notice.detail}</span>
        )}
      </p>
    );
  }

  return (
    <div
      data-testid="subscription-banner"
      className={`border-b px-4 py-2 flex items-center justify-center gap-2 text-[13px] ${styles}`}
    >
      <CalendarClock className="h-4 w-4 shrink-0" strokeWidth={1.75} />
      <span>
        <strong>{notice.title}</strong>
        {" — "}
        {notice.detail}
      </span>
    </div>
  );
}

export default function SubscriptionBanner() {
  const { user } = useAuth();
  if (!user?.organizacion_id || user?.role === "superadmin") return null;
  if (user?.solo_lectura) return null;

  return <SubscriptionNotice org={user.organizacion} />;
}
